import React from 'react';
import { Link } from 'react-router-dom';
import './contactUsFooter.css';

export default function contactUsFooter() {
    return (
        <div>
            <section className="cta-final">
                <h2>
                    LET’S <span className="red-text">TRANSFORM THE FUTURE</span><br />
                    TOGETHER
                </h2>
                <Link to="/talk-to-us" className="cta-link">
                    Book a free consultation ›
                </Link>
            </section>
        </div>
    );
}

